// ─────────────────────────────────────────────────────────────────────────────
// recipes/index.ts — Registers all built-in spells onto a SpellEngine
//
// Single entry point — callers ask `registerBuiltinSpells(engine)` and the
// engine is ready. New recipe files plug in here.
// ─────────────────────────────────────────────────────────────────────────────

import type { SpellEngine } from '../engine';
import {
  SELECT_POINT, SELECT_REGION, SELECTION_ERASE, SELECTION_CLEAR,
} from './selection_recipes';
import {
  selectPointMatcher, selectRegionMatcher, selectionEraseMatcher,
} from './selection_matchers';

export function registerBuiltinSpells(engine: SpellEngine): void {
  // Order matters — first non-null matcher wins.
  engine.register(SELECT_POINT, selectPointMatcher);
  engine.register(SELECT_REGION, selectRegionMatcher);
  engine.register(SELECTION_ERASE, selectionEraseMatcher);
  // selection.clear is registered without a matcher — debug-only invocation.
  engine.register(SELECTION_CLEAR, () => null);
}
